"use strict";
/**
 * @module "ethpm/package/resolver"
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolvedPackage = exports.Resolver = void 0;
const v3_1 = require("../../manifests/v3");
class Resolver {
    constructor(ipfsService) {
        this.ipfsBackend = ipfsService;
    }
    resolve(contentURI) {
        return __awaiter(this, void 0, void 0, function* () {
            const rawManifest = yield this.ipfsBackend.read(contentURI);
            if (!rawManifest) {
                throw new Error("Manifest at " + contentURI + " not found.");
            }
            const originalPackage = yield v3_1.v3.read(rawManifest);
            let sources = {};
            let buildDependencies = {};
            // resolve any content-addressed sources
            if (originalPackage.sources) {
                for (const sourceId in originalPackage.sources) {
                    if (Object.prototype.hasOwnProperty.call(originalPackage.sources[sourceId], 'urls')) {
                        const sourceObject = originalPackage.sources[sourceId];
                        const source = yield this.ipfsBackend.read(sourceObject['urls'][0]);
                        if (source) {
                            sources[sourceId] = {
                                content: source,
                                type: "solidity",
                                installPath: sourceId // should be optional
                            };
                        }
                        else {
                            throw new Error("No source found at " + originalPackage.sources[sourceId]);
                        }
                    }
                    else {
                        const sourceObject = originalPackage.sources[sourceId];
                        sources[sourceId] = {
                            content: sourceObject['content'],
                            type: "solidity",
                            installPath: sourceId // should be optional
                        };
                    }
                }
            }
            // resolve any build dependencies
            if (originalPackage.buildDependencies) {
                for (const key in originalPackage.buildDependencies) {
                    const url = originalPackage.buildDependencies[key];
                    const pkg = yield this.resolve(url);
                    buildDependencies[key] = pkg;
                }
            }
            return new ResolvedPackage(rawManifest, contentURI, originalPackage, buildDependencies, sources);
        });
    }
}
exports.Resolver = Resolver;
class ResolvedPackage {
    constructor(rawManifest, contentURI, originalPackage, buildDependencies, sources) {
        this.rawManifest = rawManifest;
        this.buildDependencies = buildDependencies;
        this.contentURI = contentURI;
        this.originalPackage = originalPackage;
        this.sources = sources;
    }
}
exports.ResolvedPackage = ResolvedPackage;
